import { Component, Injector } from '@angular/core';

import { MessageService } from 'primeng/api';

import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { DialogIoModel } from '../../../../Core/Dialogs/models/dialog-io.model';

import { AIRefinementDialogComponent } from '../AIRefinementDialog/AI-refinement-dialog.component';

@Component({
    selector: 'agpr-ai-refinement-popup',
    templateUrl: './AI-refinement-popup.component.html',
    styleUrls: ['./AI-refinement-popup.component.scss'],
    standalone: false
})
export class AIRefinementPopupComponent extends AIRefinementDialogComponent {

    prompt: string;
    selfClick: boolean = false;

    constructor(
        public coreDialogService: CoreDialogService,
        public configService: ConfigService,
        public messageService: MessageService,
        public localizationService: LocalizationService,
        public injector: Injector,
    ) {
        super(coreDialogService, configService, messageService, localizationService);
    }

    submitRefinementPrompt(prompt: string) {
        this.prompt = this.localizationService.transform(prompt);
        this.tryToSubmit = false;
        if (this.prompt) {
            const ioModel = this.getAIRefinementConfig();
            this.coreDialogService.open(AIRefinementDialogComponent, ioModel, this.injector);
            this.closeDialog();
        } else {
            this.tryToSubmit = true;
        }
    }

    private getAIRefinementConfig(): DialogIoModel {
        const ioModel: DialogIoModel = {
            inputs: {
                selectionHtml: this.selectionHtml,
                preSelectionHtml: this.preSelectionHtml,
                postSelectionHtml: this.postSelectionHtml,
                aiReferenceId: this.aiReferenceId,
                style: this.style,
                prompt: this.prompt,
                hideInsert: this.hideInsert
            },
            outputs: {
                dialogClose: this.dialogClose
            }
        };

        return ioModel;
    }

    clearSelectedPrompt() {
        this.selectedPrompt = '';
    }

    cancel(): void {
        this.closeDialog();
    }

    setSelf(event) {
        if (event?.stopPropagation) {
            event.stopPropagation();
        }
        this.selfClick = true;
    }
}
